export default __webpack_public_path__ + "static/media/image1.8e6bf2a8.jpg";